import { GridLocaleText } from '@mui/x-data-grid'

// eslint-disable-next-line @typescript-eslint/naming-convention
export const nlNL: Partial<GridLocaleText> = {
  // Root
  noRowsLabel: 'Geen resultaten.',
  noResultsOverlayLabel: 'Geen resultaten.',

  // Density selector toolbar button text
  toolbarDensity: 'Grootte',
  toolbarDensityLabel: 'Grootte',
  toolbarDensityCompact: 'Compact',
  toolbarDensityStandard: 'Normaal',
  toolbarDensityComfortable: 'Breed',

  // Columns selector toolbar button text
  toolbarColumns: 'Kolommen',
  toolbarColumnsLabel: 'Kies kolommen',

  // Filters toolbar button text
  toolbarFilters: 'Filters',
  toolbarFiltersLabel: 'Toon filters',
  toolbarFiltersTooltipHide: 'Verberg filters',
  toolbarFiltersTooltipShow: 'Toon filters',
  toolbarFiltersTooltipActive: (count) => (count > 1 ? `${count} actieve filters` : `${count} filter actief`),

  // Filter panel text
  filterPanelAddFilter: 'Filter toevoegen',
  filterPanelDeleteIconLabel: 'Verwijderen',
  filterPanelOperator: 'Operatoren',
  filterPanelOperatorAnd: 'En',
  filterPanelOperatorOr: 'Of',
  filterPanelColumns: 'Kolommen',

  // Column menu text
  columnMenuLabel: 'Menu',
  columnMenuShowColumns: 'Toon kolommen',
  columnMenuFilter: 'Filteren',
  columnMenuHideColumn: 'Verbergen',
  columnMenuUnsort: 'Annuleer sortering',
  columnMenuSortAsc: 'Oplopend sorteren',
  columnMenuSortDesc: 'Aflopend sorteren',

  // Column header text
  columnHeaderFiltersTooltipActive: (count) => (count > 1 ? `${count} actieve filters` : `${count} filter actief`),
  columnHeaderFiltersLabel: 'Toon filters',
  columnHeaderSortIconLabel: 'Sorteren',

  columnsManagementShowHideAllText: 'Toon/verberg alles',
  columnMenuManageColumns: 'Beheer kolommen',
  columnsManagementSearchTitle: 'Zoeken',
  pinToRight: 'Zet rechts vast',
  pinToLeft: 'Zet links vast',

  // Rows selected footer text
  footerRowSelected: (count) =>
    count > 1 ? `${count.toLocaleString()} rijen geselecteerd` : `${count.toLocaleString()} rij geselecteerd`,
  footerTotalVisibleRows: (visableCount, totalCount) =>
    `${visableCount.toLocaleString()} van de ${totalCount.toLocaleString()} rijen zichtbaar`,
  footerTotalRows: 'Totaal:',

  // custom pagination
  MuiTablePagination: {
    labelDisplayedRows: ({ from, to, count }) => (count === 0 ? '' : `${from}-${to} van ${count !== -1 ? count : to}`),
  },
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const enNL: Partial<GridLocaleText> = {
  // Root
  noRowsLabel: 'No results.',
  noResultsOverlayLabel: 'No results.',

  // Density selector toolbar button text
  toolbarDensity: 'Size',
  toolbarDensityLabel: 'Size',
  toolbarDensityCompact: 'Compact',
  toolbarDensityStandard: 'Standard',
  toolbarDensityComfortable: 'Comfortable',

  // Columns selector toolbar button text
  toolbarColumns: 'Columns',
  toolbarColumnsLabel: 'Select columns',

  // Filters toolbar button text
  toolbarFilters: 'Filters',
  toolbarFiltersLabel: 'Show filters',
  toolbarFiltersTooltipHide: 'Hide filters',
  toolbarFiltersTooltipShow: 'Show filters',
  toolbarFiltersTooltipActive: (count) => (count > 1 ? `${count} active filters` : `${count} active filter`),

  // Filter panel text
  filterPanelAddFilter: 'Add filter',
  filterPanelDeleteIconLabel: 'Delete',
  filterPanelOperator: 'Operators',
  filterPanelOperatorAnd: 'And',
  filterPanelOperatorOr: 'Or',
  filterPanelColumns: 'Columns',

  // Column menu text
  columnMenuLabel: 'Menu',
  columnMenuShowColumns: 'Show columns',
  columnMenuFilter: 'Filter',
  columnMenuHideColumn: 'Hide',
  columnMenuUnsort: 'Unsort',
  columnMenuSortAsc: 'Sort by ASC',
  columnMenuSortDesc: 'Sort by DESC',

  // Column header text
  columnHeaderFiltersTooltipActive: (count) => (count > 1 ? `${count} active filters` : `${count} active filter`),
  columnHeaderFiltersLabel: 'Show filters',
  columnHeaderSortIconLabel: 'Sort',

  // Rows selected footer text
  footerRowSelected: (count) =>
    count > 1 ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`,
  footerTotalVisibleRows: (visibleCount, totalCount) =>
    `${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()} rows visible`,
  footerTotalRows: 'Total:',

  // custom pagination
  MuiTablePagination: {
    labelDisplayedRows: ({ from, to, count }) => (count === 0 ? '' : `${from}-${to} of ${count !== -1 ? count : to}`),
  },
}
